import React from 'react';
import Dashboard from './components/Dashboard';

const App = () => {
  // Sample data of patients
  const patients = [
    { id: 'P001', name: 'Viral', age: 42, status: 'Active', appointment: 'Today, 2:30 PM', condition: 'Hypertension' },
    { id: 'P002', name: 'Michael Chen', age: 35, status: 'Active', appointment: 'Tomorrow, 10:00 AM', condition: 'Diabetes Type 2' },
    { id: 'P003', name: 'Emma Wilson', age: 28, status: 'Active', appointment: 'Apr 10, 11:15 AM', condition: 'Pregnancy - 2nd Trimester' },
    { id: 'P004', name: 'James Rodriguez', age: 52, status: 'Inactive', appointment: 'None', condition: 'Arthritis' },
    { id: 'P005', name: 'Linda Thompson', age: 63, status: 'Active', appointment: 'Apr 12, 9:45 AM', condition: 'COPD' },
  ];

  // Sample upcoming appointments
  const appointments = [
    { id: 'A001', patient: 'Sarah Johnson', time: 'Today, 2:30 PM', type: 'Follow-up', duration: '30 min' },
    { id: 'A002', patient: 'Michael Chen', time: 'Tomorrow, 10:00 AM', type: 'Consultation', duration: '45 min' },
    { id: 'A003', patient: 'Robert Lewis', time: 'Today, 4:15 PM', type: 'Lab Results', duration: '20 min' },
    { id: 'A004', patient: 'Emma Wilson', time: 'Apr 10, 11:15 AM', type: 'Prenatal Checkup', duration: '60 min' }
  ];

  return <Dashboard patients={patients} appointments={appointments} />;
};

export default App;